<script lang="ts">
	import { format } from 'src/services/i18n';
	import { Alert, Button, Container } from '@Shelly/shelly-design-system';
	import type { Device } from 'src/types/Device';
	import type { DeviceUsage } from './device_usage_helper';
	import { rooms } from 'src/stores/lists/rooms';
	import {
		getAlarmsWithDevice,
		getGroupsWithDevice,
		getScenesWithDevice,
		getDashboardsWithDevice,
		getThermostatsWithDevice,
	} from './device_usage_helper';
	import DeleteModal from './DeleteDeviceModal.svelte';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';

	export let device: Device;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);

	let deleteLoading = false;
	let showModalDelete = false;
	let deviceUsage = {
		room: [],
		group: [],
		alarm: [],
		scene: [],
		dashboard: [],
		thermostat: [],
	} as DeviceUsage;

	let deviceIsUsed = false;

	const onDeleteButtonClick = () => {
		deviceUsage = {
			room: $rooms[device.room_id] !== undefined ? [$rooms[device.room_id]] : [],
			group: getGroupsWithDevice(device.id),
			alarm: getAlarmsWithDevice(device.id),
			scene: getScenesWithDevice(device.id),
			dashboard: getDashboardsWithDevice(device.id),
			thermostat: getThermostatsWithDevice(device.id),
		} as DeviceUsage;

		deviceIsUsed = Object.values(deviceUsage).some((array) => array.length > 0);

		showModalDelete = true;
	};
</script>

<Container type="borderSolid" backgroundColor="color-base">
	{#if isSharedHomeActive}
		<SharedHomeOwnerManagedAlert class="mb-s" context="delete_entity" />
	{:else}
		<Alert
			class="mb-s"
			type="warning"
			heading={$format('delete_device_description', {
				default: 'Permanently remove this device from your account.',
			})}
		/>
	{/if}
	<Button
		class="width-sm-full"
		variant="danger"
		size="m"
		responsiveSize={{ sm: 'm' }}
		loading={deleteLoading}
		disabled={isSharedHomeActive}
		on:click={onDeleteButtonClick}
	>
		{device.shared
			? $format('remove_from_my_acc', { default: 'Remove from my account' })
			: $format('button_delete', { default: 'Delete' })}
	</Button>
</Container>

<DeleteModal
	bind:showModalDelete
	{device}
	{deviceIsUsed}
	{deviceUsage}
	on:close={() => {
		showModalDelete = false;
	}}
	on:delete={(e) => {
		deleteLoading = e.detail.deleteLoading;
	}}
/>
